import { combineReducers } from 'redux';
import authSlice from './authSlice';
import userDrugSlice from './userDrugSlice';
import modalSlice from './modalSlice';

export default combineReducers({
  authentication: authSlice.reducer,
  userDrugs: userDrugSlice.reducer,
  modal: modalSlice.reducer
});
